import React, { memo, useCallback } from "react";
import { SelectDropdown } from "@swiggy-private/dls-web-recipe-food-web/dist/components/SelectDropdown";

interface DropdownFieldProps {
    id: string;
    label: string;
    enabled: boolean;
    options?: string[];
    value?: string;
    onChange: (fieldId: string, value: string) => void;
    isDetailsSubmitted?: boolean;
}

const DropdownFieldComponent: React.FC<DropdownFieldProps> = ({
    id,
    label,
    options = [],
    value,
    onChange,
    isDetailsSubmitted,
}) => {
    const handleChange = useCallback((newValue: string) => onChange(id, newValue), [id, onChange]);

    return (
        <SelectDropdown
            key={id}
            label={label}
            name={id}
            value={value}
            options={options.map((opt: string) => ({ text: opt }))}
            disabled={isDetailsSubmitted}
            onChange={handleChange}
        />
    );
};

export default memo(DropdownFieldComponent);
